/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Tue May 23 2023
 **/

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { ZIndex } from "@/frameworks/core/commons";
import { Column, Menu, Row, Typography } from "@/frameworks/designStuff/components";

import { S } from "../../Common";

export const Header = styled(Row)`
	padding: 12px 16px;
`;

export const HeaderIconList = S.HeaderIconList;

export const DirectMessageContent = styled.div`
	width: 100%;
`;

export const DrawerContentHeader = styled(Row.div)`
	width: 100%;
	min-height: 32px;
	padding: 12px 12px 8px 8px;
`;

// ShortDirectMessage

export const ShortDirectMessageList = styled(Column.ul)`
	width: 392px;

	li {
		width: 100%;
	}
`;

export const SpaceGroup = styled.ul``;

export const SubMenu = styled(Menu)`
	position: absolute;
	top: 42px;
	left: 50%;
	transform: translateX(-50%);
	min-width: 288px;
	max-width: none;
	background-color: ${({ theme }) => theme.colors.neutral_00_100};
	z-index: ${ZIndex.POPUP};
`;

// EmptyDMChatList.tsx
//EmptyWorkGroup.tsx
export const ButtonGroup = styled(Column)`
	padding-top: 12px;
`;

export const EmptyWrap = styled(Column)`
	width: 100%;
	display: flex;
	padding: 40px 16px;
	justify-content: center;
	align-items: center;
`;

export const StyledMenu = styled(Menu)`
	background-color: ${({ theme }) => theme.colors.neutral_00_100};
`;

export const DashedLine = styled.span`
	width: 100%;
	height: 1px;
	border: 1px dashed #000;
`;

export const SpaceGroupContent = styled(Column)`
	width: 100%;

	ul {
		width: 392px;
	}
`;

export const GroupDivider = styled.span`
	display: block;
	width: 100%;
	height: 9px;
	padding: 8px 12px 12px;

	::after {
		content: "";
		display: block;
		border-bottom: ${({ theme }) => `2px dotted ${theme.colors.neutral_50_100}`};
		opacity: 0.2;
		width: 100%;
		height: 2px;
	}
`;

export const listItemCss = () => {
	return css`
		padding: 0 11px 0 8px;
	`;
};

export const Wrapper = styled(Column)`
	width: 100%;
`;

export const SpaceGroupHeader = styled(Row)`
	padding: 8px 12px 12px 8px;
	align-items: center;
`;

export const GroupName = styled(Typography.p)`
	margin-left: 4px;
`;

export const StyledRoomItem = styled.li`
	padding-left: 24px;
`;

export const HoverElm = styled(Row)<{ isExposedSpaceRoomList: boolean; activeBackground?: boolean }>`
	width: 100%;
	border-radius: 12px;
	align-items: center;
	padding: ${({ isExposedSpaceRoomList }) => (isExposedSpaceRoomList ? "4px 0px 4px 0px" : "4px 0 4px 16px")};
	background-color: ${({ theme, activeBackground }) =>
		activeBackground ? theme.colors.accent_00_100 : theme.colors.transparent};

	.more-icon {
		display: none;
	}

	&:hover {
		color: ${({ theme }) => theme.colors.primary_80_100};
		background: ${({ theme }) => theme.colors.secondary_80_8};
		.more-icon {
			display: flex;
		}
		.notify-icon {
			display: none;
		}
		.news-icon {
			display: none;
		}
	}
`;

export const SpaceChatHeader = styled(Row)`
	cursor: pointer;
`;

export const ToggleButtonCard = styled(Menu.Item)`
	.buttonText {
		width: 100%;
		display: flex;
		align-items: center;
		gap: 12px;
	}
`;
